// extracted by mini-css-extract-plugin
export default {"container":"indicators_container__HWtiM","col":"indicators_col__GErFx","title":"indicators_title__75q+1","subtitle":"indicators_subtitle__0XsXV"};